<template>
    <div>
        <div id="hero-banner">
            <div class="bg-parallax banner-image" data-inverted="true" data-speed="0.1" :style="bannerStyle"></div>
            <div class="overlay text-center">
                <h1 id="hero-text">TERMS AND CONDITIONS</h1>
                <h1 id="hero-sub-text">FOR THE SUPPLY OF SERVICES</h1>
            </div>
        </div>

        <div class="container pt-6 pb-8">
        <supply-of-services-section />
        <performance-of-services-section />
        <prices-of-services-section />
        <payment-of-services-section />
        <refund-and-credit-section />
        <cancellation-and-termination-section />
        <limitation-of-liability-section />
        <settlement-of-dispute-section />
        <questions-and-complaints-section />
        <miscellaneous-section />
        </div>
    </div>
</template>
<script>
import { resource } from "@utils/network";
import SupplyOfServicesSection from "./partials/SupplyOfServicesSection";
import PerformanceOfServicesSection from "./partials/PerformanceOfServicesSection";
import PricesOfServicesSection from "./partials/PricesOfServicesSection";
import PaymentOfServicesSection from "./partials/PaymentOfServicesSection";
import RefundAndCreditSection from "./partials/RefundAndCreditSection";
import CancellationAndTerminationSection from "./partials/CancellationAndTerminationSection";
import LimitationOfLiabilitySection from "./partials/LimitationOfLiabilitySection";
import SettlementOfDisputeSection from "./partials/SettlementOfDisputeSection";
import QuestionsAndComplaintsSection from "./partials/QuestionsAndComplaintsSection";
import MiscellaneousSection from "./partials/MiscellaneousSection";

export default {
    name: "SupplyOfServicesPage",
    components: {
        SupplyOfServicesSection,
        PerformanceOfServicesSection,
        PricesOfServicesSection,
        PaymentOfServicesSection,
        RefundAndCreditSection,
        CancellationAndTerminationSection,
        LimitationOfLiabilitySection,
        SettlementOfDisputeSection,
        QuestionsAndComplaintsSection,
        MiscellaneousSection,
    },
    computed: {
        bannerStyle() {
            return `background-image:url('${ resource("images/about-us-header.jpg") }')`;
        }
    },
}
</script>
<style lang="css" scoped>
    #hero-banner {
        position: relative;
        height: 800px;
        overflow: hidden;
    }
    #hero-banner .banner-image {
        height: 100%;
        background-position-x: 50%;
    }
    #hero-text {
        margin: 400px 0 0 0;
        font-family: 'Montserrat', sans-serif;
        color: white;
        text-transform: uppercase;
        font-size: 3.8rem;
        font-weight: 800;
        line-height: 1.5;
    }
    #hero-sub-text {
        margin-top: -20px;
        color: white;
        text-transform: uppercase;
        font-size: 1.6rem;
        font-weight: 400;
        line-height: 1.5;
    }
    #hero-banner .overlay {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.6);
        top: 0px;
    }
    .company-banner {
        width: 100%;
    }
    h2.display-4 {
        font-family: 'Montserrat', sans-serif;
    }
</style>